import { useEffect } from 'react';
import { goldenPinPurchaseEvent } from '../../../../services/analyticsService';
import { GOLDEN_PIN_SLUG } from '../../utils/goldenPin';
import { readPendingCards, writePendingCards } from './goldenPinTracking';

const PENDING_CARD_TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Fires `golden_pin_purchase` for card purchases once My Listings reports the pin applied
 * (a pending record is written when the cart is created). `listings` are the mapped rows
 * (tableData.list); golden pin info is on property.productsInfo.
 */
export const useGoldenPinLifecycleEvents = (user, listings) => {
  useEffect(() => {
    if (!user?.id || !listings?.length) return;

    const pending = readPendingCards(user.id);
    const pendingIds = Object.keys(pending);
    if (!pendingIds.length) return;

    const next = { ...pending };
    pendingIds.forEach((listingId) => {
      const record = pending[listingId];
      if (Date.now() - (record?.ts || 0) > PENDING_CARD_TTL_MS) {
        delete next[listingId];
        return;
      }
      const listing = listings.find((l) => String(l?.id) === String(listingId));
      if (listing && listing?.property?.productsInfo?.[GOLDEN_PIN_SLUG]?.is_applied) {
        goldenPinPurchaseEvent(user, {
          listing: {
            id: listingId,
            purpose: record.purpose,
            location: { title: record.city, breadcrumb: record.location },
            area: record.area,
          },
          price: record.price,
          durationDays: record.duration_days,
          paymentMethod: 'card',
        });
        delete next[listingId];
      }
    });
    if (Object.keys(next).length !== pendingIds.length) writePendingCards(user.id, next);
  }, [user, listings]);
};
